import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-305915cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }

import { ref, computed } from "vue";
import { useAuthStore } from "@/store/auth/login";

import InnerPageLayout from "@/widgets/layouts/InnerPageLayout.vue";
import TopAdsCabinetPanel from "@/entities/dictionaries/ads_cabinets/panels/TopAdsCabinetPanel.vue";
import AdsCabinetCreateForm from "@/entities/dictionaries/ads_cabinets/forms/AdsCabinetCreateForm.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdsCabinetPage',
  setup(__props) {

const isLoading = ref(false);
const createFormRef = ref(null);
const authStore = useAuthStore();

const createAdsCabinet = () => {
  if (createFormRef.value) createFormRef.value.createAdsCabinet();
};

const setLoading = (value: boolean) => {
  isLoading.value = value;
};

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["dictionaries:read", "dictionaries:edit"]
  );
});

const isButtonDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:edit"],
    ["dictionaries:edit"]
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnerPageLayout, null, {
    default: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(TopAdsCabinetPanel, {
            isLoading: isLoading.value,
            isButtonDisabled: isButtonDenied.value,
            onCreateAdsCabinet: createAdsCabinet
          }, null, 8, ["isLoading", "isButtonDisabled"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(AdsCabinetCreateForm, {
              isLoading: isLoading.value,
              onSetLoading: setLoading,
              ref_key: "createFormRef",
              ref: createFormRef
            }, null, 8, ["isLoading"])
          ])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})